<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import estimatedCostPicture from "src/pages/components/estimated-cost/picture/modules/estimated-cost-picture";
@Component({
  name: "estimatedcost-picture",
  components: { estimatedCostPicture }
})
export default class App extends Vue {
  list = [];
  pagination = {
    pageNumber: 1,
    pageSize: 200
  }
  setList(list) {
    return list.reduce((pre, next) => {
      console.log(pre);
      const lastIndex = pre.length - 1;
      if (
        !pre[lastIndex] ||
        (pre[lastIndex] && pre[lastIndex].length >= 6 * 3)
      ) {
        pre.push([]);
      }
      pre[pre.length - 1].push(next);
      return pre;
    }, []);
  }
  POST_PROJECT_COST_BOARD_PAGE(params) {
    return new Promise((resolve, reject) => {
      this.$apis.autoAPi
        .POST_PROJECT_COST_BOARD_PAGE(params)
        .done(res => {
          let list = this.setList(res.data)
          if(list.length == 0) {
            resolve([])
          } else {
            resolve(list)
          }
        })
        .fail(err => {
          reject([])
        });
    })
  }



  mounted() {
    let that = this
    const { type } = this.$route.query;
    that.pageType = type;
    const params = window.localStorage.getItem("estimatedCost-picture__query");
    that.$emit("handleIsLoading", true);
    getAllList().then(res => {
      that.$emit("handleIsLoading", false);
    }).catch(err => {

    })
    function getAllList() {
      return that.POST_PROJECT_COST_BOARD_PAGE({
        ...JSON.parse(params),
        ...that.pagination
      }).then(list => {   
        if(list.length == 0) {
          return Promise.resolve()
        } else {
          that.list = [...that.list, ...list]
          that.pagination.pageNumber += 1
          return getAllList()
        }
      }).catch(err => {

      })
    }
  }
  render(h) {
    return (
      <div class="estimatedcost-picture-print">
        {this.list.map((item, $index) => {
          return (
            <div class="estimatedcost-picture-print__page">
              {item.map(inner => {
                return (
                  <estimated-cost-picture info={inner}></estimated-cost-picture>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }
}
</script>

<style lang="scss">
@media print {
  .estimatedcost-picture-print__page {
    page-break-inside: avoid !important;
    page-break-before: unset !important;
    -webkit-print-color-adjust: exact;
  }
}
.estimatedcost-picture-print__page {
  width: calc(365px * 6);
  page-break-inside: avoid !important;
    page-break-before: unset !important;
  display: flex;
  flex-wrap: wrap;
}
.estimatedcost-picture-print {
  background: #fff;
}
</style>
